import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Source from "./Source";
import Fetcher from "../Provider/Fetcher";

/**
 * @classdesc OrientedImageSource is a specific source used to load oriented images.
 * @extends Source
 */
var OrientedImageSource = /*#__PURE__*/function (_Source) {
  _inherits(OrientedImageSource, _Source);
  var _super = _createSuper(OrientedImageSource);
  /**
   * @constructor
   * @param { Object } source - Configuration object
   * @param { string } source.url - Url for all the textures.
   * @param { string } source.orientationsUrl - Json Url, using GeoJSon format to represent points,
   * it's a set of panoramic position and orientation.
   * @param { string } source.calibrationUrl - Json url, representing a set of camera. see [CameraCalibrationParser]{@link module:CameraCalibrationParser}
   * This Url must contains {sensorId} and {cameraId}, and these pattern will be replaced to build the Url,
   * to find the good texture for each camera for each panoramic.
   */
  function OrientedImageSource(source) {
    var _this;
    _classCallCheck(this, OrientedImageSource);
    source.format = source.format || 'json';
    _this = _super.call(this, source);
    _this.isOrientedImageSource = true;

    // Fetch the two files
    var promises = [];
    promises.push(source.orientationsUrl ? Fetcher.json(source.orientationsUrl, _this.networkOptions) : Promise.resolve());
    promises.push(source.calibrationUrl ? Fetcher.json(source.calibrationUrl, _this.networkOptions) : Promise.resolve());
    _this.whenReady = Promise.all(promises).then(function (data) {
      return {
        orientation: data[0],
        calibration: data[1]
      };
    });
    return _this;
  }

  /**
   * Build the url of the texture, but not from extent.
   *
   * @param      {Object}  imageInfo - Information about the texture
   * @param      {string}  imageInfo.camera - Id of the camera
   * @param      {string}  imageInfo.pano - Id of the panoramic
   * @return     {string}  Url of the image
   */
  _createClass(OrientedImageSource, [{
    key: "urlFromExtent",
    value: function urlFromExtent(imageInfo) {
      return this.imageUrl(imageInfo.cameraId, imageInfo.panoId);
    }
  }, {
    key: "requestToKey",
    value: function requestToKey(image) {
      return [image.cameraId, image.panoId];
    }

    /**
     * Build the url of the image, for a given panoramic id, and a given camera id.
     *
     * @param      {string}  cameraId  Id of the camera
     * @param      {string}  panoId   Id of the panoramic
     * @return     {string}  Url of the image
     */
  }, {
    key: "imageUrl",
    value: function imageUrl(cameraId, panoId) {
      return this.url.replace('{cameraId}', cameraId).replace('{panoId}', panoId);
    }
  }]);
  return OrientedImageSource;
}(Source);
export default OrientedImageSource;